<template>
  <div id="app">
    <router-view />
    <!-- 加载 -->
    <div class="appLoading" v-if="overAllLoading.status">
      <div class="appLoadingMain indexJust">
        <loading-module :textInfo="overAllLoading.info" />
      </div>
    </div>
  </div>
</template>

<script>
import loadingModule from '@/components/module/loading/loading.vue';
import { mapState } from 'vuex';
export default {
  name: 'App',
  components: {
    loadingModule
  },
  computed: {
    ...mapState(['overAllLoading'])
  }
};
</script>

<style lang="scss">
// @import '@/assets/scss/index.scss';
@import './assets/scss/common.scss';
@import './assets/scss/projectFiltering/index.scss'; // 新版
// @import './assets/scss/projectFiltering/index_old.scss'; // 旧版

.indexJust {
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
}

.alignItems {
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  // -webkit-justify-content: center;
  // justify-content: center;
  // -webkit-justify-content: center;
  align-items: center;
}

.typeList div.cur {
  background-color: #fff;
  border: 1px solid $mainColor;
  color: $mainColor;
}
</style>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  width: 100%;
  height: 100%;
}
html,
body {
  width: 100%;
  height: 100%;
}
p {
  margin-block-start: 0;
  margin-block-end: 0;
}

.pl6 {
  padding-left: 6px;
}

.text-hidden {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.detailsAlert-text .el-statistic .con .number {
  font-weight: 400 !important;
  font-size: 14px;
  display: inline-block;
  width: 100%;
  line-height: 40px;
  text-align: center;
}
.table .el-statistic .con .number {
  font-weight: 400 !important;
  font-size: 14px;
  display: inline-block;
  width: 100%;
  text-align: left;
}

.typeList div b {
  margin-left: 10px;
}

.el-submenu [class^='el-icon-'] {
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 22px;
  color: #333;
}

.el-tooltip__popper {
  max-width: 50%;
}

.nowrap {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.pl5 {
  padding-left: 5px;
}

.el-menu-item [class^='el-icon-'] {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 22px;
  color: #333;
  vertical-align: middle;
}

body {
  padding-right: 0 !important;
  position: relative;
}

.el-dialog__headerbtn {
  font-size: 30px !important;
  z-index: 2;
}

.el-table {
  color: #444444 !important;
}

.buton {
  background: #f6f7fb;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  padding: 10px 0px 16px 20px;
}

.greed {
  color: #30bf30;
  display: inline-block;
  padding: 0 2px;
}

.bold {
  font-weight: 600;
}
.color9 {
  color: #999;
}

.bule {
  color: #1268cc;
}
.green {
  color: #30bf30;
}

.redD90 {
  color: #d9001b;
}
.c333 {
  color: #333;
}

.bgffd70b {
  background: #ffd70b;
}

.pointer {
  cursor: pointer;
  padding-left: 5px;
}
.position-right {
  position: absolute;
  right: 20px;
  top: 70px;
}
.text-center {
  text-align: center;
}
.img-right {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
}
.fixed {
  width: 100%;
  height: 100vh;
  display: flex;
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1111;
}
.fixed-video {
  background: #ffffff;
  width: 680px;
  height: 480px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -330px;
  margin-top: -240px;
}
.fixed-video-box {
  padding: 0 20px;
}
/* 大屏的标题样式 */
.full-title {
  height: 44px;
  line-height: 44px;
  background: url('./../static/large/min-title.png') no-repeat;
  font-size: 18px;
  font-family: Medium;
  font-weight: 400;
  padding-left: 32px;
}

/*弹出框效果 打开*/
@-webkit-keyframes bounceInOpen {
  0% {
    opacity: 0;
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes bounceInOpen {
  0% {
    opacity: 0;
    -webkit-transform: scale(0.1);
    -ms-transform: scale(0.1);
    transform: scale(0.1);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
}

.bounceInOpen {
  -webkit-animation: bounceInOpen 0.5s;
  animation: bounceInOpen 0.5s;
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #cfcbcb;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}
.flexh {
  background: white;
  width: 100%;
  height: 100%;
}
/* 按钮 输入框 全局更改32px */
.el-input__inner {
  height: 32px;
  line-height: 32px;
}
.el-button {
  padding: 8px 10px;
}
.el-button--success,
.el-button--success:hover {
  background: #30bf30;
  background-color: #30bf30;
  color: white;
}
/* .el-input__icon {
  line-height: 32px;
} */
.el-date-editor .el-range__icon,
.el-date-editor .el-range-separator {
  line-height: 24px;
}

.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background: white !important;
}

/* 加载 */
.appLoading,
.appLoadingMain {
  width: 100%;
  height: 100%;
}
.appLoading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2600;
}
</style>



// WEBPACK FOOTER //
// src/App.vue